// ONE AT A TIME ACCORDION
const accordionWraps = document.querySelectorAll('.c-accordions');
if(accordionWraps.length > 0) {
  accordionWraps.forEach(accordionWrap => {
    if(accordionWrap.dataset.variant === 'one-at-a-time') {
      const accordions = accordionWrap.querySelectorAll('.c-accordion');
      accordions.forEach(accordion => {
        accordion.addEventListener('click', function() {
          accordions.forEach(accordion => {
            if(accordion !== this) {
              accordion.querySelector('.c-accordion-checkbox').checked = false;
            }
          });
        });
      });
    }
  });
}


const allClubsDropdown = document.querySelectorAll('.c-dropdown-wrap.all-clubs');
if(allClubsDropdown.length > 0) {
  allClubsDropdown.forEach(dropdown => {
    const dropdownLinks = dropdown.querySelectorAll('.c-dropdown-list button');
    const homeClub = dropdown.querySelector('.c-home-club');
    dropdownLinks.forEach(dropdownLink => {
      dropdownLink.addEventListener('click', function() {
        const locationId = this.dataset.locationId;
        const accordions = document.querySelectorAll('.c-accordions-wrap.all-clubs .c-accordion .c-accordion-checkbox');
        accordions.forEach(checkbox => {
          checkbox.checked = false;
        });
        const checkbox = document.querySelector(`.c-accordion-checkbox[data-location-id="${locationId}"]`);
        if(checkbox) {
          checkbox.checked = true;
        }

        dropdownLinks.forEach(dropdownLink => {
          if(dropdownLink !== this) {
            dropdownLink.classList.remove('active');
          } else {
            dropdownLink.classList.add('active');
            dropdownLink.blur();

            homeClub.textContent = dropdownLink.textContent;
            dropdown.classList.remove('is-open');
          }
        });
      });
    });
  });
}